import React, { useEffect, useState } from "react";

export default function ArticleImportEditableText({ value, label, error, onCommit, disabled = false }) {
  const [draft, setDraft] = useState(value ?? "");
  useEffect(() => setDraft(value ?? ""), [value]);
  return <input disabled={disabled} aria-label={label} aria-invalid={Boolean(error)} value={draft} title={String(draft)}
    onChange={event => setDraft(event.target.value)}
    onBlur={() => { if (draft !== value) onCommit(draft); }}
    onKeyDown={event => {
      if (event.key === "Enter") event.currentTarget.blur();
      if (event.key === "Escape") setDraft(value ?? "");
    }} />;
}
